/* istanbul ignore file */

export const SORT_BY = 'Sort by';
export const SORT_CTA = 'Sort';
export const FILTER_CTA = 'Filter';
export const FILTER_AND_SORT_CTA = 'Filter & Sort';
export const RESET_ALL = 'Reset all';
export const SORT_CLOSE_CTA = 'Close';
export const SORT_APPLY_CTA = 'Apply';
